import moment from 'moment';
import { gsap } from 'gsap';

import store from '@tvguide/store';

/**
 * Check if date have enough programs in store
 * @param  {String} date The date to check
 * @return {Boolean}
 */
export const checkDateHasProgram = date => {
  const currentState = store.getState();
  const channels = currentState.channels;
  const targetDate = moment(date);
  let programAverage = 0;

  channels.forEach(c => {
    programAverage += c.programs.filter(p => {
      return targetDate.isSame(moment(p.start_time), 'day');
    }).length;
  });
  programAverage = programAverage / channels.length;

  return !(channels.length < 1 || programAverage < 10);
};

export const scrollGridToTarget = (target, time = 0, cb = function() {}) => {
  const grid = document.querySelector('#sm-container');
  const timeline = document.querySelector('#timeline-container');
  const channelListEl = document.querySelector('.tvg-channel-list');
  let centerOffset = window.innerWidth / 2 - channelListEl.offsetWidth;

  if (time > 0) {
    const minutesPixelRatio = store.getState().ux.minutesPixelRatio;
    centerOffset -= minutesPixelRatio * time;
  }

  gsap.to(grid, {
    scrollLeft: target.offsetLeft - centerOffset,
    onComplete: cb,
    duration: 0.5,
  });
  gsap.to(timeline, {
    scrollLeft: target.offsetLeft - centerOffset,
    duration: 0.5,
  });
};

/**
 * Scroll grid of given duration
 * @param  {Number} duration Duration in minutes to scroll
 */
export const scrollGridForDuration = duration => {
  const grid = document.querySelector('#sm-container');
  const timeline = document.querySelector('#timeline-container');
  const minutesPixelRatio = store.getState().ux.minutesPixelRatio;
  const scrollDistance = duration * minutesPixelRatio;

  gsap.to(grid, {
    scrollLeft: grid.scrollLeft + scrollDistance,
    duration: 0.3,
  });
  gsap.to(timeline, {
    scrollLeft: timeline.scrollLeft + scrollDistance,
    duration: 0.3,
  });
};
